(() => {
  const desktopQuery = window.matchMedia('(min-width: 1024px)');

  const moveDesktopControls = (section) => {
    const toolbar = section.querySelector('[data-collection-v2-toolbar]');
    if (!toolbar) return;

    const filtersHost = toolbar.querySelector('[data-collection-v2-filters]');
    const sortHost = toolbar.querySelector('[data-collection-v2-sort]');
    const columnsHost = toolbar.querySelector('[data-collection-v2-columns]');
    const filtersForm = section.querySelector('collection-filters-form');
    const sidebarWrapper = section.querySelector('.m-sidebar .m-filter--wrapper');
    const sort = section.querySelector('.m-toolbar--sortby[data-toolbar-sorting]');
    const columns = section.querySelector('.m-toolbar--column-switcher');

    if (desktopQuery.matches) {
      if (filtersForm && filtersHost && filtersForm.parentElement !== filtersHost) filtersHost.append(filtersForm);
      if (sort && sortHost && sort.parentElement !== sortHost) sortHost.append(sort);
      if (columns && columnsHost && columns.parentElement !== columnsHost) columnsHost.append(columns);
    } else {
      if (filtersForm && sidebarWrapper && filtersForm.parentElement !== sidebarWrapper) sidebarWrapper.append(filtersForm);
      const toolbarRight = section.querySelector('.m-collection-toolbar .m-toolbar--right');
      if (sort && toolbarRight && sort.parentElement !== toolbarRight) toolbarRight.prepend(sort);
      if (columns && toolbarRight && columns.parentElement !== toolbarRight) toolbarRight.append(columns);
    }

    toolbar.querySelectorAll('.m-filter--widget').forEach((dropdown) => {
      dropdown.classList.add('collection-v2-filter');
      dropdown.querySelector('.m-filter--widget-title')?.setAttribute('aria-expanded', 'false');
    });
  };

  const closeDropdowns = (section, except) => {
    section.querySelectorAll('.collection-v2-filter.is-open').forEach((dropdown) => {
      if (dropdown !== except) {
        dropdown.classList.remove('is-open');
        dropdown.querySelector('.m-filter--widget-title')?.setAttribute('aria-expanded', 'false');
      }
    });
  };

  const initialise = (root = document) => {
    root.querySelectorAll?.('.facest-filters-section').forEach((section) => {
      moveDesktopControls(section);
      if (section.dataset.collectionV2Ready === 'true') return;
      section.dataset.collectionV2Ready = 'true';

      section.addEventListener('click', (event) => {
        const title = event.target.closest('.collection-v2-toolbar .m-filter--widget-title');
        if (!title || !desktopQuery.matches) return;
        const dropdown = title.closest('.m-filter--widget');
        if (!dropdown) return;
        event.preventDefault();
        const willOpen = !dropdown.classList.contains('is-open');
        closeDropdowns(section, dropdown);
        dropdown.classList.toggle('is-open', willOpen);
        title.setAttribute('aria-expanded', String(willOpen));
      });

      document.addEventListener('click', (event) => {
        if (!desktopQuery.matches) return;
        if (!event.target.closest('[data-collection-v2-toolbar]')) closeDropdowns(section);
      });
    });
  };

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.facest-filters-section').forEach((section) => closeDropdowns(section));
  });

  const remount = () => initialise();
  const restoreDesktopGrid = () => {
    if (!desktopQuery.matches) return;
    const section = document.querySelector('.facest-filters-section');
    const configuredColumns = Number(section?.dataset.initialColumn);
    // A desktop grid must not inherit mobile's two-column class. If the
    // section is still configured as 2, use the desktop four-column layout.
    const desktopColumns = configuredColumns > 2 ? configuredColumns : 4;
    const productGrid = section?.querySelector('[data-product-container]');
    if (!productGrid) return;

    productGrid.classList.remove('m-cols-1', 'm-cols-2', 'm-cols-3', 'm-cols-4', 'm-cols-5');
    productGrid.classList.add(`m-cols-${desktopColumns}`);
    window.localStorage.setItem('gridColumnViews', desktopColumns);

    // Keep Minimog's controller state in sync when it is available.
    if (MinimogTheme.Collection) MinimogTheme.Collection.activeCol = desktopColumns;
  };

  document.addEventListener('DOMContentLoaded', remount);
  document.addEventListener('collection:rerendered', remount);
  desktopQuery.addEventListener('change', () => {
    remount();
    if (desktopQuery.matches) window.setTimeout(restoreDesktopGrid, 600);
  });

  // Minimog stores one grid preference for every breakpoint. A mobile visit
  // therefore leaves a 2-column preference behind for desktop. On the first
  // desktop visit in this browser session, return to the section's configured
  // desktop column count; later desktop choices remain untouched.
  window.addEventListener('load', () => {
    window.setTimeout(() => {
      if (!desktopQuery.matches || sessionStorage.getItem('collectionV2DesktopGridSet')) return;
      restoreDesktopGrid();
      sessionStorage.setItem('collectionV2DesktopGridSet', 'true');
    }, 0);
  });
})();
